export function scrollSlider() {
    const WIN = $(window);
    const $bl = $(".scroll-slider-section");
    const $wrap = $bl.find(".scroll-slider-wrap");
    const $bottomContent = $bl.find(".scroll-slider-outer");
    const $holder = $bl.find(".scroll-slider");
    const paddingShift = 20;
    let data = null;
    let timerId = null;

    init();

    function init() {
        WIN.on("load", function () {
            timerId = setTimeout(() => {
                getData();
                setProperty();
                setEvents();
                setHolderPosition();
            }, 1000);
        });
    };

    function getData() {
        data = {
            window: {
                width: WIN.innerWidth(),
                height: WIN.innerHeight()
            },
            holder: {
                top: $holder.offset().top,
                width: $holder.innerWidth(),
                height: $holder.innerHeight(),
                center: $holder.offset().top + $holder.innerHeight() / 2,
            },
        };
        const { window, holder } = data;
        const difference = holder.width - window.width;
        if (holder.width < window.width - paddingShift) {
            data.blockHeight = "auto";
            data.maxShiftValue = 0;
            $holder.css("margin-left", `${-(difference + 1.5 * paddingShift) / 2}px`);
        } else {
            data.blockHeight = `${$bottomContent.outerHeight(true) + difference}px`;
            data.maxShiftValue = difference + 2 * paddingShift;
            $holder.css("margin-left", "0");
        };
    };

    function setProperty() {
        const { holder, blockHeight } = data;
        $holder.css("--half-height", `${holder.height / 2}px`);
        $wrap.css("height", `${blockHeight}`);
    };

    function setHolderPosition() {
        const { window, holder, maxShiftValue } = data;
        const scrollTop = WIN.scrollTop();
        const scrollCenter = scrollTop + window.height / 2;
        if (scrollCenter < holder.center) {
            return $holder.css("transform", `translateX(${0}px)`);
        } else {
            const shiftValue = scrollCenter - holder.center;
            if (shiftValue > maxShiftValue) return $holder.css("transform", `translateX(${-maxShiftValue}px)`);
            $holder.css("transform", `translateX(${-(shiftValue)}px)`);
        }
    }

    function setEvents() {
        WIN.on("scroll", function () {
            setHolderPosition();
        });

        WIN.on("resize", function () {
            if (timerId) clearTimeout();
            setTimeout(() => {
                getData();
                setProperty();
                setHolderPosition();
            }, 1000);
        });
    };
};


// WEBPACK FOOTER //
// ./assets/js/modules/scrollSlider.js